<template>
  <div class="container">
    <div class="row paymentFailed">
      <div class="col">
        <div class="row">
          <div class="col text-center">
            <div class="text-center">
              <img src="/assets/images/icons/logo-false.png" class="logo-width" alt="">
            </div>
            <h4 class="pt-5">تعذّر إتمام عملية الدفع</h4>
            <p class="gray-text">نأسف، لم تكتمل عملية الدفع بنجاح. يُرجى المحاولة مرة أخرى أو التواصل <br>  معنا للمساعدة.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'paymentfailed',
}
</script>